<template>
  <div class="app" :class="appClasses">
    <router-view/>
    <ninja-loader :show="showLoader" :initial="!appLoaded" :fullscreen="true" />
    <transition name="fade">
      <VideoLightbox
        key="hero-video-lightbox"
        v-if="heroVideoExpanded"
      />
      <SubmissionLightbox
        key="submission-lightbox"
        v-if="lightboxExpanded"
      />
    </transition>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import FontFaceObserver from 'fontfaceobserver';

import ImagePreload from './core/image-preload';
import { FONT_FAMILY_BASE_FIXED, FONT_FAMILY_RED_BULL_H_1 } from '../design-tokens/build/dictionary';
import { heroCarouselImages, backgroundImages } from './core/image-config';

import VideoLightbox from './components/video-lightbox';
import SubmissionLightbox from './components/submission-lightbox';

import iframeChannel from './core/iframe-channel';

import './core/media-listeners';


const baseFont = new FontFaceObserver(FONT_FAMILY_BASE_FIXED);
const headingFont = new FontFaceObserver(FONT_FAMILY_RED_BULL_H_1);

const imagesToPreload = [
  ...heroCarouselImages,
  ...backgroundImages,
];

const appImages = new ImagePreload(imagesToPreload);

export default {
  name: 'app',
  components: {
    VideoLightbox,
    SubmissionLightbox,
  },
  props: {
  },
  data() {
    return {
      showLoader: true,
      appLoaded: false,
    };
  },
  created() {
  },
  mounted() {
    Promise.all([
      baseFont.load(),
      headingFont.load(),
      appImages.loadAll(),
      iframeChannel.ready,
    ]).then(() => {
      this.appLoaded = true;
      this.showLoader = false;
    });
  },
  computed: {
    appClasses() {
      return {
        [`app--${this.$route.name}`]: true,
        'app--entry-view': this.entryView,
        'app--loaded': this.appLoaded,
      };
    },
    ...mapState('ui', [
      'entryView'
    ]),
    ...mapState('ui', [
      'heroVideoExpanded'
    ]),
    ...mapState('submissionView', [
      'lightboxExpanded'
    ]),
  },
  methods: {

  }
};
</script>

<style lang="scss">
@import 'assets/styles/global';
</style>
